// react components
import React, {
    useState,
} from 'react'
import {
    IonButtons,
} from '@ionic/react'

// data
import {
    contentTypeModelTypeSite,
} from 'data'

// pages
import {
    ActionComponent825,
} from 'pages'

// serializers
import {
    ContentTypeSettingsTypes,
    ContentTypeSettingsCustomTypes,
} from 'serializers/site'

// props
type DetailAction825Props = {
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    contentTypeSettingsCustom: ContentTypeSettingsCustomTypes | undefined
    inModal?: boolean
    object: {
        id?: number
        active?: boolean
        hostname?: string
        member?: {
            id?: number
            slug?: string
        }
        name?: string
        profile?: {
            id?: number
            slug?: string
        }
        owner_info?: {
            content_uuid?: string
            permission?: boolean
        }
        slug?: string
    }
    refreshData: () => void
    subContentTypeForced?: { id: number, name: string }
}

// main
export const DetailAction825: React.FC<DetailAction825Props> = React.memo(({
    contentType,
    contentTypeSettings,
    contentTypeSettingsCustom,
    inModal,
    object,
    refreshData,
    subContentTypeForced,
}) => {

    const [showActionPopover, setShowActionPopover] = useState(false)

    if (!object.id) return null

    return (
        <React.Fragment>
            <IonButtons
                className='detail-action'
                slot='start'
            >
                <ActionComponent825
                    contentType={contentType}
                    contentTypeSettings={contentTypeSettings}
                    defaultFields={undefined}
                    edit={false}
                    inDetail
                    inModal={inModal}
                    object={object}
                    refreshData={refreshData}
                    setShowActionPopover={setShowActionPopover}
                    showActionPopover={showActionPopover}
                    subContentTypeForced={subContentTypeForced}
                />
            </IonButtons>
        </React.Fragment>
    )
})
